import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import SessionBox from "../../components/form/SessionBox";
import OText, { OThemeText } from "../../components/text/OText";
import ProgressSession from "../../components/card/ProgressSession";
import I18n from "../../i18n";
import { Sessions } from "../../util/appointments";
import Colors, { StaticColor } from "../../theme/Colors";
import { isAlive, ColorUtil } from "../../util/index";

function createDataCounter() {
	return {
		[Sessions.COMPLETED]: {
			text: I18n.t(`sessions.${Sessions.COMPLETED}`),
			color: StaticColor.Sessions[Sessions.COMPLETED],
			value: 0,
			session: 0
		},
		[Sessions.ONGOING]: {
			text: I18n.t(`sessions.${Sessions.ONGOING}`),
			color: StaticColor.Sessions[Sessions.ONGOING],
			value: 0,
			session: 0
		},
		[Sessions.PENDING]: {
			text: I18n.t(`sessions.${Sessions.PENDING}`),
			color: StaticColor.Sessions[Sessions.PENDING],
			value: 0,
			session: 0
		},
		[Sessions.INCOMPLETE]: {
			text: I18n.t(`sessions.${Sessions.INCOMPLETE}`),
			color: StaticColor.Sessions[Sessions.INCOMPLETE],
			value: 0,
			session: 0
		},
		[Sessions.CANCELLED]: {
			text: I18n.t(`sessions.${Sessions.CANCELLED}`),
			color: StaticColor.Sessions[Sessions.CANCELLED],
			value: 0,
			session: 0
		}
	};
}
const UsedSession = props => {
	const {
		style,
		colStyle = undefined,
		gutter = 16,
		maxPerLine = 2,
		showSessions = Object.values(Sessions).splice(1),
		appointments = [],
		allLength = 0
		// sessionValue = 470,
		// maxSession = 500,
		// pureNumber = true,
		// sessionDatas = mockupSessionDatas,
	} = props;
	const usedData = createDataCounter();
	let allSession = 0;

	if (isAlive(appointments)) {
		for (let i = 0; i < appointments.length; i += 1) {
			usedData[appointments[i].status].value += 1;
			// if (appointments[i].reserved_duration)
			if (appointments[i].reserved_duration) {
				usedData[appointments[i].status].session +=
					appointments[i].reserved_duration / 30;
				allSession += appointments[i].reserved_duration / 30;
			}
			if (appointments[i].extension_duration) {
				usedData[appointments[i].status].session +=
					appointments[i].extension_duration / 30;
				allSession += appointments[i].extension_duration / 30;
			}
		}
	}
	const spanSize = 24 / maxPerLine;
	return (
		<Row
			style={style}
			gutter={gutter}
			type="flex"
			justify="center"
			align="middle"
		>
			<Col span={spanSize} style={{ ...colStyle, marginBottom: gutter }}>
				<ProgressSession
					value={allLength}
					// max={maxSession}
					// showMax={maxSession!==0}
					label={I18n.t("all_visits")}
					// pureNumber = {pureNumber}
				/>
				<ProgressSession
					value={allSession}
					// max={maxSession}
					// showMax={maxSession!==0}
					label={I18n.t("all_session")}
					// pureNumber = {pureNumber}
				/>
			</Col>
			{/* <Col span={spanSize} style={{...colStyle, marginBottom:gutter}}>
            <SessionBox text={I18n.t('sessions.all')} 
                value={allLength} color={Colors.blackColor} />
        </Col> */}
			{showSessions.map((key, i) => {
				const sesData = usedData[key];
				return (
					<Col
						key={i}
						span={spanSize}
						style={{ ...colStyle, marginBottom: gutter }}
					>
						<SessionBox
							text={sesData.text}
							value={sesData.value}
							color={sesData.color}
							session={sesData.session}
						/>
					</Col>
				);
			})}
			<Col>
				<span>
					<p style={{ color: "red" }}>
						*Visit = 1 video call case e.g. 60 minutes continuous video call
						will be counted as 1 visit
					</p>
				</span>
			</Col>
		</Row>
	);
};
export default UsedSession;



// WEBPACK FOOTER //
// ./src/containers/HomePanels/UsedSession.js